import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Size } from '../../Constants/System';
import { StyledInputWrapper } from './InputStyles';
import { ValidationState } from './ValidationSection';
export const DefaultStyledInputProps = {
    $size: Size.medium,
    $validationState: ValidationState.None,
};
const SimpleInput = forwardRef((props, ref) => {
    const [hasNonEmptyValue, setHasNonEmptyValue] = useState(!!props.value);
    const [isFocused, setIsFocused] = useState(false);
    useEffect(() => setHasNonEmptyValue(!!props.value), [props.value]);
    const handleFocus = (e) => {
        setIsFocused(true);
        props.onFocus?.(e);
    };
    const handleBlur = (e) => {
        setIsFocused(false);
        props.onBlur?.(e);
    };
    const handleChange = (e) => {
        setHasNonEmptyValue(!!e.target.value);
        props.onChange?.(e);
    };
    const { label, placeholder } = props;
    const hasNonEmptyLabel = label != undefined && label.length > 0;
    const hasNonEmptyPlaceholder = placeholder != undefined && placeholder.length > 0;
    const { children, styleProps, ...propsWithoutChildren } = props;
    const styleInputProps = {
        ...DefaultStyledInputProps,
        ...styleProps,
        $hasLabel: hasNonEmptyLabel,
        $isDisabled: props.disabled ?? false,
        $labelInsideInput: styleProps?.$labelInsideInput !== false && !(hasNonEmptyPlaceholder || isFocused || hasNonEmptyValue),
    };
    return (_jsxs(StyledInputWrapper, { ...styleInputProps, ref: props.wrapperRef, className: props.className, children: [props.label ? _jsx("label", { children: props.label }) : '', _jsx(StyledInput, { ...propsWithoutChildren, ref: ref, onFocus: handleFocus, onBlur: handleBlur, onChange: handleChange }), children] }));
});
SimpleInput.displayName = 'SimpleInput';
export default SimpleInput;
const StyledInput = styled.input ``;
//# sourceMappingURL=SimpleInput.js.map